import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Helpers } from '../../../../app/helpers';
import { appService } from '../../../../app/_services/app.service';

@Component({
  selector: 'app-driver-consent',
  templateUrl: './driver-consent.component.html',
  styleUrls: ['./driver-consent.component.scss']
})
// Added by priya - 02/04/2026 - cn(PRIYA-APR26-001)
export class DriverConsentComponent implements OnInit {

  @Output() onCloseEvent = new EventEmitter<any>();
  @Input() DriverMobileNo: any;
  @Input() BookingId: any;
  driverConsentData: any = [];
  static that: DriverConsentComponent;
  driverMessage: any;

  constructor(
    private _appService: appService
  ) { 
    DriverConsentComponent.that = this;
  }

  ngOnInit() {
    this.CheckDriverConsents(this.BookingId, this.DriverMobileNo)
  }

  CheckDriverConsents(bookingId, DriverMobileNo) {
    Helpers.setLoading(true);
    this.driverConsentData = [];
    var settingsCheckDriverConsents = {
      async: true,
      crossDomain: true,
      url: "https://sct.intutrack.com/api/test/consents?tel=" + DriverMobileNo,
      method: "GET",
      headers: {
        authorization:
            "Basic c0dGMHBqMnRvcG01SzdUa05KUUhIZWxCRXQyOHROVGEzbktNVU40ajNTSUk3VVowM0hGS21ReHlXUWtiOWhQMjo1eVA4UEFhSXROUDRsNFIwNkJNRDBQQ1FpbFdlNkM2bmhlRmNjbDhGWlRIeURqWGRZRllncEQybU54OHBVTzlx",
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache",
        username:
            "sGF0pj2topm5K7TkNJQHHelBEt28tNTa3nKMUN4j3SII7UZ03HFKmQxyWQkb9hP2",
        password:
            "5yP8PAaItNP4l4R06BMD0PCQilWe6C6nheFccl8FZTHyDjXdYFYgpD2mNx8pUO9q",
      },
    };
    $.ajax(settingsCheckDriverConsents).done(function (response) {
      if (response != null) {
        DriverConsentComponent.that.driverConsentData.push(response[0].result);
        DriverConsentComponent.that.GetMessage(bookingId, DriverMobileNo)
      }
    });
    Helpers.setLoading(false);
  }

  GetMessage(bookingId, DriverMobileNo){
    this._appService.GetByTwoId("so_GoodsOutward", "GetSimTrackingMsgViaNumber", bookingId, DriverMobileNo).subscribe((response) => {
      DriverConsentComponent.that.driverMessage = response[0].Message;
    },
    (err) => {
      Helpers.setLoading(false);
    });
  }

  onclose(){
    this.onCloseEvent.emit();
  }

}
